import BoxImage from "@components/BoxImage";
import BoxVideoThumbnail from "@components/BoxVideoThumbnail";
import ButtonContainer from "@components/ButtonContainer";
import { timestampToString } from "@helpers/dates.format";
import { ReactElement } from "react";
import { TCreateMediaDto } from "types/Media/createMediaDto";
import styles from "./DetailMedia.module.scss";
import { isYoutubeUrl } from "@helpers/youtube.helper";

interface IDetailForm {
  data: TCreateMediaDto;
}

const DetailMedia = ({ data }: IDetailForm): ReactElement => (
  <form className={`${styles.detailForm} form`}>
    <div className="form__form-group">
      <span className="form__form-group-label">Title</span>
      <div className="form__form-group-field">
        <input type="text" value={data?.title} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Date</span>
      <div className="form__form-group-field">
        <input value={timestampToString(data?.date)} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Type</span>
      <div className="form__form-group-field">
        <input value={data?.type} disabled />
      </div>
    </div>

    {data?.gallery && data?.gallery.length > 0 && (
      <div className="form__form-group">
        <span className="form__form-group-label">Gallery</span>
        <div className="form__form-group-field">
          <div className={styles.gallery}>
            {data.gallery.map((item) =>
              item.mediaUrl.includes("mp4") ? (
                <BoxVideoThumbnail url={item.mediaUrl} isPreview />
              ) : isYoutubeUrl(item.mediaUrl) ? (
                <BoxVideoThumbnail url={item.mediaUrl} isPreview isYoutube />
              ) : (
                <BoxImage urlImage={item.mediaUrl} key={item.mediaUrl} />
              )
            )}
          </div>
        </div>
      </div>
    )}

    <ButtonContainer />
  </form>
);

export default DetailMedia;
